import { institutionTypeDomaine, roles } from "../../../utils/constants";
import { useParams } from "react-router-dom";
import routes from "../../../engine/routes";
import { userHasLevel } from "../../../engine/AuthRoute";
import { isSuperAdmin } from "../../../engine/hooks/hooks.helpers";
import {
  mainTypesPrestation,
  typesPrestation,
} from "../../../utils/typesPrestation";
import { Button, notification } from "antd";
import { http } from "../../../engine/api/http";
import React from "react";
import BillingsType from "./index";

export const institutionsDetailinputs = ({ institution, formRef, user }) => {
  const {
    name,
    secondName,
    type,
    archived,
    principal,
    mainType,
    groupedBilling,
    tags,
    restrictionPerApplicant,
    readOnlyPrestation,
    restrictionFollowPrestation,
    interventionLocation,
    billings,
    abacusId = "",
    notification = {},
  } = institution;
  const { id } = useParams();

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "Nom 1",
          name: "name",
          value: name,
          required: true,
          type: "input",
          capitalize: false,
          col: 24,
        },
        {
          label: "Nom 2",
          name: "secondName",
          value: secondName,
          type: "input",
          col: 24,
        },
        {
          value: mainType,
          label: "Domaine principal",
          name: "mainType",
          showSearch: true,
          type: "select",
          selectContent: mainTypesPrestation,
          selectType: "group",
          col: 24,
        },

        {
          label: "Mandant global",
          name: "principal",
          value: principal?._id,
          allowClear: true,
          type: "dynamic-select",
          endPoint: routes.principals().path,
          disabled: !userHasLevel({
            only: {
              [roles.permanance]: "crud", //
              [roles.admin]: "crud", //
            },
          }),
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Paramètres",
      children: [
        {
          value: tags,
          label: "Tags",
          name: "tags",
          multiple: "true",
          disabled: true,
          showSearch: true,
          type: "select-add",
          selectContent: [],
          col: 24,
        },
        // {
        //   label: "Facturation groupée",
        //   description:
        //     "Les factures seront regroupées par mois lors de la génération",
        //   name: "groupedBilling",
        //   disabled: true,
        //   type: "checkbox-bool",
        //   value: groupedBilling,
        //   col: 24,
        // },
        {
          visible: userHasLevel({
            only: {
              [roles.admin]: "crud", //
            },
          }),
          label: "Restriction des prestations par demandeur",
          name: "restrictionPerApplicant",
          type: "checkbox-bool",
          value: restrictionPerApplicant,
          description:
            "Seuls les administrateurs de cette institution peuvent accéder à toutes les demandes de l'institution. Chaque utilisateur ne peut accéder qu'à ses propres demandes.",
          col: 24,
        },
        {
          visible: userHasLevel({
            only: {
              [roles.admin]: "crud", //
            },
          }),
          label: "Restreindre les commandes de prestations",
          name: "readOnlyPrestation",
          type: "checkbox-bool",
          value: id === "new" ? true : readOnlyPrestation,
          description:
            "Les utilisateurs de cette institution ont un accès en lecture seule à leurs prestations, sans possibilité de création, modification ou annulation",
          col: 24,
        },
        {
          visible: userHasLevel({
            only: {
              [roles.admin]: "crud", //
            },
          }),
          label: "Restreindre la création de suivi pour cette institution",
          name: "restrictionFollowPrestation",
          type: "checkbox-bool",
          value: id === "new" ? false : restrictionFollowPrestation,
          description: "Seuls les utilisateurs AVIC peuvent créer des suivis.",
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Notifications",
      children: [
        {
          visible: userHasLevel({
            only: {
              [roles.admin]: "crud", //
            },
          }),
          label:
            "Activer les notifications de cloture de prestation pour le client",
          name: "notification.cloturePrestation",
          type: "checkbox-bool",
          value: id === "new" ? true : notification.cloturePrestation,
          description:
            "Le responsable et demandeur recoivent un email de confirmation de cloture de prestation",
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Facturation",
      children: [
        {
          visible: userHasLevel({
            only: {
              [roles.admin]: "r",
              [roles.permanance]: "r",
            },
          }),
          label: "ID Abacus",
          name: "abacusId",
          value: abacusId,
          type: "input",
          capitalize: false,
          disabled: !isSuperAdmin(),
          col: 24,
        },
        {
          label: null,
          name: "billings",
          type: "component",
          component: ({}) => {
            return (
              <div
                style={{
                  borderTop: "1px solid #f0f0f0",
                  marginTop: 8,
                  paddingTop: 24,
                }}
              >
                <BillingsType
                  title="Règles de facturation"
                  description="Les factures seront regroupées par mois lors de la génération"
                  billings={billings}
                  name={"billings"}
                  refForm={formRef}
                />
              </div>
            );
          },
          col: 24,
        },
      ],
    },
    {
      children: [
        // {
        //   type: "component",
        //   component: () =>
        //     userHasLevel({
        //       only: {
        //         [roles.admin]: "crud", //
        //       },
        //     }) ? (
        //       <>
        //         <Button
        //           type={"primary"}
        //           onClick={async () => {
        //             const res = await http.post("/bills/multiple", {
        //               institutionId: id,
        //             });
        //             notification.success({
        //               message: `Factures créées`,
        //             });
        //           }}
        //         >
        //           Générer les factures
        //         </Button>
        //       </>
        //     ) : null,
        // },
        {
          label: id === "new" ? "Créer l'institution" : "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
